import React, { useState } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Input, Switch, Typography } from "antd";
import { validationLetter, validationCompanyDocument } from "utils/form/validations";
import { validationCharacters } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";
const { Title } = Typography;

export interface IData {
  setChecked: (...args) => void;
  checked: boolean;
}

const DataTabPane = ({ setChecked, checked }: IData) => {
  const [value, setValue] = useState("");

  const onChangeUnitState = (checkedUnit) => {
    setChecked(checkedUnit);
  };

  const validationFields = (e, validationType) => {
    validationCharacters(e, validationType);
  };

  return (
    <>
      <S.ContainerLocationActive>
        <div>
          <Switch
            className="switch-component"
            data-testid="activeLocation"
            checked={checked}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            onChange={onChangeUnitState}
          />
          <Title level={5} style={S.DescriptionActiveLocation}>
            {`${useTranslation({ id: "active_location" })}`}
          </Title>
        </div>
        <div></div>
      </S.ContainerLocationActive>
      <S.FirstLine>
        <S.FormItemFieldName
          name="description"
          label={`${useTranslation({ id: "name" })}*`}
          style={S.RequiredDescriptionField}
          hasFeedback
          rules={[
            {
              required: true,
              message: useTranslation({ id: "required_field" }),
            },
          ]}
        >
          <Input style={S.InputField} data-testid="name-description" />
        </S.FormItemFieldName>
        <S.FormItem name="companyDocument" label={`${useTranslation({ id: "company_document" })}`} style={S.DescriptionField}>
          <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyPress={(e) => validationFields(e, validationCompanyDocument)}
            style={S.InputField}
            data-testid="company-document"
            maxLength={18}
          />
        </S.FormItem>
        <S.FormItem
          name="code"
          label={`${useTranslation({ id: "location_code" })}*`}
          style={S.RequiredDescriptionField}
          hasFeedback
          rules={[
            {
              required: true,
              message: useTranslation({ id: "required_field" }),
            },
          ]}
        >
          <Input style={S.InputField} data-testid="location-code" />
        </S.FormItem>
      </S.FirstLine>
      <S.SecondLine>
        <S.FormItem name="country" label={`${useTranslation({ id: "country" })}`} style={S.DescriptionField}>
          <Input style={S.InputField} data-testid="country" />
        </S.FormItem>
        <S.FormItem name="addressState" label={`${useTranslation({ id: "address_state" })}`} style={S.DescriptionField}>
          <Input style={S.InputAddressState} maxLength={2} showCount data-testid="address-state" onKeyPress={(e) => validationFields(e, validationLetter)} />
        </S.FormItem>
        <S.FormItem name="city" label={`${useTranslation({ id: "city" })}`} style={S.DescriptionField}>
          <Input style={S.InputField} data-testid="city-description" />
        </S.FormItem>
      </S.SecondLine>
    </>
  );
};

export default DataTabPane;
